import { render, staticRenderFns } from "./ModalAddIgnoredLpfr.vue?vue&type=template&id=4636562e&"
import script from "./ModalAddIgnoredLpfr.vue?vue&type=script&lang=js&"
export * from "./ModalAddIgnoredLpfr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports